<mat-form-field>
  <mat-label>{{ 'general.title' | translate }}</mat-label>
  <input [(ngModel)]="notification.title" matInput required maxlength="40"/>
  <mat-hint align="end" [class.red]="notification.title?.length >= 35">{{ notification.title?.length || 0 }} / 40</mat-hint>
</mat-form-field>
<div class="error" *ngIf="errors.includes('title')">{{ 'notifications.errors.title' | translate }}</div>

<mat-form-field class="description">
  <mat-label>Text</mat-label>
  <textarea [(ngModel)]="notification.text" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10" maxlength="160"></textarea>
  <mat-hint align="end" [class.red]="notification.text?.length >= 150">{{ notification.text?.length || 0 }} / 160</mat-hint>
</mat-form-field>
<div class="error" *ngIf="errors.includes('text')">{{ 'notifications.errors.text' | translate }}</div>

<mat-form-field (click)="selectContent($event)" (focusin)="selectContent($event)" class="select-content">
  <mat-label>Verknüpfter Inhalt</mat-label>
  <input [(ngModel)]="contentTitle" matInput readonly>
  <button (click)="selectContent($event)" mat-icon-button matSuffix>
    <mat-icon>edit</mat-icon>
  </button>
  <button (click)="$event.stopPropagation(); removeContent($event)" mat-icon-button matSuffix>
    <mat-icon>delete</mat-icon>
  </button>
</mat-form-field>
<div class="error" *ngIf="errors.includes('content')">{{ 'notifications.errors.content' | translate }}</div>

<data-table *ngIf="groups?.length" [columns]="groupColumns" [headerButtons]="headerButtons" [title]="'notifications.groups' | translate"
            (remove)="removeGroup($event)" [hideSearch]="true" [newHeader]="true" [plainData]="(activeGroups || [])" noDataMessage="notifications.noGroups"></data-table>
<div class="error groups" *ngIf="errors.includes('groups')">{{ 'notifications.errors.groups' | translate }}</div>

<h3>Zustellung</h3>

<div class="sending">
  <ibex-checkbox [checked]="notification.instant" [title]="'notifications.instant' | translate" (click)="notification.instant = $event.val"></ibex-checkbox>

  <ng-container *ngIf="notification?.instant !== true">
    <mat-form-field class="minimize-height-sm">
      <input [(ngModel)]="notification.publishStart" [matDatepicker]="startPicker" matInput placeholder="{{'notifications.startDate' | translate}}" [min]="today">
      <mat-datepicker-toggle [for]="startPicker" matPrefix>
        <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="minimize-height-sm">
      <input [(ngModel)]="notification.publishStartTime" matInput placeholder="{{'notifications.startTime' | translate}}">
      <button (click)="openTimePicker(notification.publishStartTime, 'startPublishing')" mat-icon-button matPrefix>
        <mat-icon>access_time</mat-icon>
      </button>
    </mat-form-field>
  </ng-container>
</div>
<div class="error" *ngIf="errors.includes('publishing')">{{ 'notifications.errors.publishing' | translate }}</div>
<div class="error" *ngIf="errors.includes('publishingWrong')">{{ 'notifications.errors.publishingWrong' | translate }}</div>

<div class="button-right-container">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
</div>
